import { BannedTailNumbersForm } from '@lp/features/admin/forms/BannedTailNumbersForm';
import {
  BANNED_TAIL_NUMBERS_DEFAULT_VALUES,
  bannedTailNumbersFormSchema,
} from '@lp/features/admin/forms/BannedTailNumbersForm/config';
import { AdminPageHeader, Form, AdminFormAction } from '@ui';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AuthContext } from '@lp/core/auth';
import { useContext } from 'react';
import { useCreateBannedTailNumberMutation } from '@/queries/banned-tail-numbers';
import { retrieveUnifiedError } from '@/api/utils';
import { AdminPermissions } from '@/permissions';
import { BannedTailNumberFormType } from '@/api/apis/resources';

export const BannedTailNumbersCreate = () => {
  const navigate = useNavigate();
  const { mutateAsync } = useCreateBannedTailNumberMutation();
  const { checkPermission } = useContext(AuthContext);

  const hasCreatePermissions = checkPermission(AdminPermissions.ProvidersConfigurationCreate);

  const handleBackToList = () => {
    navigate('/admin/configuration/banned_tail_numbers');
  };

  const handleSubmit = async (data: BannedTailNumberFormType) => {
    try {
      await mutateAsync({
        tailNumber: data.tailNumber,
        logisticProviderId: data.logisticProviderId ? data.logisticProviderId : null,
        comment: data.comment,
      });

      toast.success(`Banned Tail Number created successfully.`);

      handleBackToList();
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return (
    <Form<BannedTailNumberFormType>
      defaultValues={BANNED_TAIL_NUMBERS_DEFAULT_VALUES}
      schema={bannedTailNumbersFormSchema}
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-9">
        <AdminPageHeader title="Add Banned Tail Number" backToListLink="/admin/configuration/banned_tail_numbers">
          <AdminFormAction type="create" handleClick={handleBackToList} hasCreatePermissions={hasCreatePermissions} />
        </AdminPageHeader>
        <BannedTailNumbersForm />
      </div>
    </Form>
  );
};
